import { prop } from "ramda";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFormAsyncErrors, getFormMeta, getFormSyncErrors } from "redux-form";

import { type IAppState } from "../../redux/reducer.js";

const useGetFormError = (formName: string): string => {
  const state = useSelector<IAppState, IAppState>((state) => state);
  const [formError, setFormError] = useState<string>(null);
  useEffect(() => {
    const formSyncErrors = getFormSyncErrors(formName)(state);
    const formAsyncErrors = getFormAsyncErrors(formName)(state);
    const formMeta = getRegisteredFields(formName, state);

    for (let i = 0; i < Object.keys(formMeta).length; i++) {
      const key: string = Object.keys(formMeta)[i];

      if (formMeta[key].touched) {
        if (formSyncErrors && prop(key, formSyncErrors)) {
          setFormError(prop(key, formSyncErrors));
          return;
        }
        if (formAsyncErrors && prop(key, formAsyncErrors)) {
          setFormError(prop(key, formAsyncErrors));
        }
      }
    }
    setFormError(null);
  }, [state.form]);

  return formError;
};

/*
 getting directly the getFormMeta() elements (e.g. in order to find out which fields are in error state)
 is misleading since the field might have been unregistered in between, but they will still be provided by redux-form
 (is this a bug?), so we need to check ourselves what fields are actually currently registered using the
 "count" property from the 'registeredFields' object.
*/
const getRegisteredFields = (formName: string, state: IAppState) => {
  // same type as getFormMeta(..)
  const form = state.form[formName];
  const registeredFields = form?.registeredFields;
  const formMeta = getFormMeta(formName)(state);
  const registeredFieldsFormMeta = {};

  if (registeredFields) {
    for (let i = 0; i < Object.keys(registeredFields).length; i++) {
      const key: string = Object.keys(registeredFields)[i];
      const registeredFieldFormMeta = prop(key, formMeta); // deep get since we should also support field arrays
      if (registeredFields[key].count > 0 && !!registeredFieldFormMeta) {
        registeredFieldsFormMeta[key] = registeredFieldFormMeta;
      }
    }
  }
  return registeredFieldsFormMeta;
};

export { useGetFormError };
